(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-reviews"] && !Shopify.designMode) return;
  try {
    
  class GmReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this._scroll(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this._scroll(1));
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      this.track && this.track.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }

    _cardStep() {
      const card = this.track.querySelector('.gm-reviews__card');
      if (!card) return 320;
      const styles = getComputedStyle(this.track);
      const gap = parseInt(styles.columnGap || styles.gap || 16, 10) || 16;
      return card.offsetWidth + gap;
    }

    _scroll(dir) {
      this.track.scrollBy({ left: dir * this._cardStep(), behavior: 'smooth' });
    }

    _onScroll() { this._update(); }

    _update() {
      if (!this.track) return;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }
  if (!customElements.get('gm-reviews-slider')) customElements.define('gm-reviews-slider', GmReviewsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-shop-by-vehicle"] && !Shopify.designMode) return;
  try {
    
  class GmSbvSlider extends HTMLElement {
    constructor() { super(); this._onScroll = this._onScroll.bind(this); }
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.cards = this.querySelectorAll('.gm-sbv__card');
      if (!this.track) return;
      this.prevBtn && this.prevBtn.addEventListener('click', () => this._scroll(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this._scroll(1));
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._update();
      // Hover-play videos on cards
      this.cards.forEach((card) => {
        const video = card.querySelector('.gm-sbv__card-video');
        if (!video) return;
        card.addEventListener('mouseenter', () => { video.currentTime = 0; video.play().catch(() => {}); });
        card.addEventListener('mouseleave', () => { video.pause(); });
      });
    }
    _step() {
      const card = this.track.querySelector('.gm-sbv__card-item');
      if (!card) return 320;
      const styles = getComputedStyle(this.track);
      const gap = parseInt(styles.columnGap || styles.gap || 16, 10) || 16;
      return card.offsetWidth + gap;
    }
    _scroll(dir) { this.track.scrollBy({ left: dir * this._step(), behavior: 'smooth' }); }
    _onScroll() { this._update(); }
    _update() {
      if (!this.track) return;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }
  if (!customElements.get('gm-sbv-slider')) customElements.define('gm-sbv-slider', GmSbvSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-timeline"] && !Shopify.designMode) return;
  try {
    
  class GmTimelineSlider extends HTMLElement {
    constructor() { super(); this._onScroll = this._onScroll.bind(this); }
    connectedCallback() {
      this.viewport = this.querySelector('.gm-timeline__viewport');
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      // CTA — smooth-scroll to top of page when data-gm-scroll-top is set.
      const cta = this.querySelector('.gm-timeline__cta[data-gm-scroll-top]');
      if (cta) {
        cta.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      if (!this.viewport || !this.track) return;
      this.prevBtn && this.prevBtn.addEventListener('click', () => this._scroll(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this._scroll(1));
      this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._update();
    }
    _step() {
      const item = this.track.querySelector('.gm-timeline__item');
      if (!item) return 320;
      const styles = getComputedStyle(this.track);
      const gap = parseInt(styles.columnGap || styles.gap || 16, 10) || 16;
      return item.offsetWidth + gap;
    }
    _scroll(dir) { this.viewport.scrollBy({ left: dir * this._step(), behavior: 'smooth' }); }
    _onScroll() { this._update(); }
    _update() {
      const atStart = this.viewport.scrollLeft <= 1;
      const atEnd = this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }
  if (!customElements.get('gm-timeline-slider')) customElements.define('gm-timeline-slider', GmTimelineSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((d) => d.close && d.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal && this.searchModal.close(false); }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
    class GmMbSlider extends HTMLElement {
      constructor() { super(); this._onScroll = this._onScroll.bind(this); }
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        if (!this.track) return;
        this.prevBtn && this.prevBtn.addEventListener('click', () => this._scroll(-1));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this._scroll(1));
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._update();
      }
      _step() {
        const card = this.track.querySelector('.gm-mb__card-item');
        if (!card) return 320;
        const styles = getComputedStyle(this.track);
        const gap = parseInt(styles.columnGap || styles.gap || 16, 10) || 16;
        return card.offsetWidth + gap;
      }
      _scroll(dir) { this.track.scrollBy({ left: dir * this._step(), behavior: 'smooth' }); }
      _onScroll() { this._update(); }
      _update() {
        if (!this.track) return;
        const atStart = this.track.scrollLeft <= 1;
        const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
      }
    }
    if (!customElements.get('gm-mb-slider')) customElements.define('gm-mb-slider', GmMbSlider);
  
  } catch(e) { console.error(e); }
})();
})();
